<template>
  <div class="container-general">
    <div class="bannerBienvenida-container">
      <div class="container-column-desp">
        <div class="bannerBienvenida-text">
          <img
            alt="Logo regalo"
            class="bannerBienvenida-img"
            src="@/assets/img/banners/oferta/bienvenida/gift-box.svg"
          />
          <h2 class="bannerBienvenida-title">
            {{ title }}
          </h2>
          <p class="bannerBienvenida-subtitle">
            {{ subtitle }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cashbackPaquetes } from "@/config/constants/packageAwards";
import { packageCode } from "@/config/constants/packagesCodes";

export default {
  name: "BannerBienvenidaOferta",
  props: {
    title: String,
    codigoPaquete: String
  },

  computed: {
    premioSegunPaquete() {
      switch (this.codigoPaquete) {
        case packageCode.LIBRETON_PREMIUM:
          return cashbackPaquetes.LIBRETON_PREMIUM;
        case packageCode.LIBRETON_PREMIUM_WORLD:
          return cashbackPaquetes.LIBRETON_PREMIUM_WORLD;
        case packageCode.LIBRETON_FULL:
          return cashbackPaquetes.LIBRETON_FULL;
        case packageCode.LIBRETON_PLUS_GOLD:
          return cashbackPaquetes.LIBRETON_PLUS_GOLD;
        case packageCode.LIBRETON_EXPRESS:
          return cashbackPaquetes.LIBRETON_EXPRESS;
        default:
          return "";
      }
    },
    subtitle() {
      return `Hasta ${this.premioSegunPaquete} en tu tarjeta de crédito`;
    }
  }
};
</script>

<style scoped>
.container-general {
  background: linear-gradient(
    180deg,
    rgba(212, 237, 252, 0.15) 0%,
    #d4edfc 51.56%,
    rgba(212, 237, 252, 0.15) 100%
  );
  min-height: 407px;
  position: relative;
  margin-top: 44px;
}

.container-column-desp {
  display: flex;
  align-items: center;
}

.bannerBienvenida-img {
  width: 86px;
  padding-top: 25px;
  margin: 0 auto;
}

.bannerBienvenida-container {
  background-image: url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg");
  background-position: left 51px top 52px, left 207px top 92px,
    left 423px top 52px, right 482.19px top 51px, right 145.14px top 51px,
    right 18.19px top 69px, left 43px top 160px, left 180px top 243px,
    right 196.19px top 216px, right 38.14px top 228px, left 50px bottom 49px,
    left 428px bottom 25px, right 576.14px bottom 21px,
    right 390.19px bottom 31px, right 172.14px bottom 43px;
  background-size: 33px, 24px, 33px, 24px, 33px, 24px, 24px, 33px, 24px, 33px,
    24px, 24px, 33px, 24px, 33px;
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
    no-repeat, no-repeat, no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
    no-repeat, no-repeat, no-repeat;
  width: 100%;
  max-width: 1280px;
  min-height: 407px;
  margin: auto;
}

.bannerBienvenida-text {
  color: #ffffff;
  display: flex;
  align-content: flex-end;
  justify-content: center;
  flex-direction: column;
  font-size: 24px;
  width: 100%;
  max-width: 975px;
  text-align: center;
  margin: 0 auto;
}

.bannerBienvenida-title {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 36px;
  line-height: 40px;
  margin: 24px 15px;
  color: #121212;
}

.bannerBienvenida-subtitle {
  font-size: 24px;
  font-weight: 350;
  line-height: 32px;
  color: #121212;
  margin: 0 0 33px;
}

.bannerBienvenida-description {
  font-size: 22px;
  font-weight: 350;
  line-height: 32px;
  text-align: center;
  color: #121212;
  margin: 0 auto;
  max-width: 585px;
}
@media (max-width: 1150px) and (min-width: 850px) {
  .bannerBienvenida-container {
    background-image: url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg");
    background-position: left 51px top 52px, left 207px top 92px,
      left 323px top 52px, right 345.19px top 51px, right 145.14px top 51px,
      right 18.19px top 69px, left 43px top 160px, left 180px top 243px,
      right 196.19px top 216px, right 38.14px top 228px, left 50px bottom 49px,
      left 328px bottom 25px, right 390.19px bottom 31px,
      right 172.14px bottom 43px;
    background-size: 33px, 24px, 33px, 24px, 33px, 24px, 24px, 33px, 24px, 33px,
      24px, 24px, 24px, 33px;
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
      no-repeat, no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
      no-repeat, no-repeat, no-repeat;
  }
}

@media (max-width: 850px) and (min-width: 600px) {
  .bannerBienvenida-title {
    font-size: 28px;
    line-height: 32px;
  }

  .bannerBienvenida-subtitle {
    font-size: 20px;
    line-height: 24px;
  }

  .bannerBienvenida-container {
    background-image: url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg");
    background-position: left 10px top 25px, right 0px top 0px,
      left 10px bottom 0px, right 10px bottom 30px, right 30px top 50px;
    background-size: 33px, 33px, 33px, 33px, 24px;
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
  }
}

@media (max-width: 600px) {
  .container-general {
    margin-top: 16px;
    min-height: 194px;
    max-height: 194px;
  }

  /* Banner Despegar */
  .container-column-desp {
    min-height: inherit;
  }

  .bannerBienvenida-text {
    min-height: inherit;
  }

  .bannerBienvenida-img {
    width: 42px;
    padding-top: 20px;
  }

  .bannerBienvenida-title {
    font-size: 12px;
    line-height: 16px;
    margin: 8px 21px 4px;
  }

  .bannerBienvenida-subtitle {
    font-size: 10px;
    line-height: 12px;
    margin: 0 21px 28px;
  }

  .bannerBienvenida-description {
    font-size: 8px;
    line-height: 12px;
    margin: 0 55px 40px;
  }

  .bannerBienvenida-container {
    background-image: url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg");
    background-position: left 18.5px top 20.66px, left 120px top 19.76px,
      right 60.19px top 14.37px, right 8.03px top 20.66px,
      left 13.04px bottom 63.77px, left 29px bottom 16.17px,
      left 163px bottom 8.98px, right 29.97px bottom 17.96px,
      right 5.95px bottom 58.38px;
    background-size: 15.05px, 9.03px, 15.05px, 9.03px, 9.03px, 15.05px, 9.03px,
      9.03px, 15.05px;
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
      no-repeat, no-repeat, no-repeat, no-repeat;
    min-height: 194px;
  }
}

@media (max-width: 351px) {
  .bannerBienvenida-title {
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 5px;
  }

  .bannerBienvenida-subtitle {
    font-size: 8px;
    line-height: 12px;
  }

  .container-general {
    min-height: 194px;
    max-height: 194px;
  }

  .bannerBienvenida-container {
    min-height: 140px;
  }
}
</style>
